module.exports = {"330902002":"昌国街道","330902003":"环南街道","330902004":"城东街道","330902005":"盐仓街道","330902006":"临城街道","330902007":"岑港街道","330902008":"马岙街道","330902009":"双桥街道","330902010":"小沙街道","330902100":"金塘镇","330902104":"白泉镇","330902105":"干览镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330902.json
// module id = 933
// module chunks = 0